import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { IApiInvestigation } from 'src/app/shared/modules/graphql/types/types';
import { LoaderService } from 'src/app/shared/modules/loader/loader.service';
import { NotificationsService } from 'src/app/shared/modules/notifications/notifications.service';
import { InvestigationService } from 'src/app/shared/services';

@Component({
  selector: 'app-add-comment-modal',
  templateUrl: './add-comment-modal.component.html',
  styleUrls: ['./add-comment-modal.component.scss']
})
export class AddCommentModalComponent extends DialogContentBase {

  @ViewChild('commentForm', { static: false }) commentForm: NgForm;
  @Input() data: IApiInvestigation;
  public comment = "";

  constructor(
    public dialog: DialogRef,
    private loaderService: LoaderService,
    private investigationService: InvestigationService,
    private notifications: NotificationsService
  ) {
    super(dialog);
  }

  public close(result = false) {
    this.dialog.close(result);
  }

  addComment(reactivate = false) {
    if (this.commentForm?.invalid) {
      this.commentForm.form.markAllAsTouched();
      return;
    };

    this.loaderService
      .show$(
        this.investigationService.investigationReactivateRequest({
          reactivate: reactivate,
          comment: this.comment,
          InvestigationId: this.data.id,
        }).pipe(
          this.notifications.snackbarErrorPipe(),
          this.notifications.snackbarPipe(reactivate ? "Reactivation requested added successfully" : "Comment added successfully"),
        )
      )
      .subscribe((res) => {
        this.close()
      });
  }
}
